import React from 'react';
import dynamic from 'next/dynamic';
import loading from '../lib/loading';
import InView from './InView';

const DynamicFooterComponent = dynamic(() => import('./Footer'), {
  ssr: false,
  loading,
});

const DynamicFooter = () => (
  <InView tag="footer">
    <DynamicFooterComponent />
  </InView>
);

export default DynamicFooter;
